import { Component, computed, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import {
  Notification,
  NotificationAction,
  NotificationType
} from '@gfe/core/models/notifications.model';
import { ICONS } from '@gfe/core/services/icons/icons.service';

const STRIPE_COLORS: Record<NotificationType, string> = {
  [NotificationType.SUCCESS]: 'var(--success)',
  [NotificationType.ERROR]: 'var(--danger)',
  [NotificationType.WARNING]: 'var(--warning)',
  [NotificationType.INFO]: 'var(--info)'
};

@Component({
  selector: 'app-notification',
  imports: [TranslatePipe],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.css'
})
export class NotificationComponent {
  notification = input.required<Notification>();
  dismiss = output<string>();
  pauseEvent = output<string>();
  resumeEvent = output<string>();

  protected readonly ICONS = ICONS;

  stripeColor = computed(
    () => STRIPE_COLORS[this.notification().type] ?? 'var(--border-default)'
  );

  isPersistent = computed(() => !this.notification().duration);

  iconClass = computed(() => {
    switch (this.notification().type) {
      case NotificationType.SUCCESS:
        return `${ICONS.checkCircle} text-success`;
      case NotificationType.ERROR:
        return `${ICONS.xCircle} text-danger`;
      case NotificationType.WARNING:
        return `${ICONS.warning} text-warning`;
      case NotificationType.INFO:
        return `${ICONS.info} text-info`;
      default:
        return `${ICONS.bell} text-text-secondary`;
    }
  });

  onDismiss(): void {
    this.dismiss.emit(this.notification().id);
  }

  onMouseEnter(): void {
    this.pauseEvent.emit(this.notification().id);
  }

  onMouseLeave(): void {
    this.resumeEvent.emit(this.notification().id);
  }

  executeAction(action: NotificationAction): void {
    action.action();
  }
}
